import React from "react";
export function Identification() {
  return <section className="bg-ink-2" data-id="element-66" data-mp="1lrzpwaugvnt6">
      <div className="mx-auto max-w-5xl px-6 py-16 sm:py-24" data-id="element-67" data-mp="2l9ggakzbtyjq">
        <h2 className="mb-6 font-serif text-[30px] font-bold leading-tight sm:text-5xl" data-id="element-68" data-mp="2l8yfrc5msy60">
          ¿Tenés ganas de empezar, pero no sabés qué vender?
        </h2>
        <p className="max-w-3xl text-lg leading-relaxed text-soft" data-id="element-69" data-mp="2v02r81w3m0w3">
          Quizás ya viste videos sobre ebooks, inteligencia artificial y negocios digitales. Pero cuando te sentás a
          hacerlo, aparecen las dudas: qué tema elegir, cómo crear el producto y cómo conseguir compradores.
        </p>
        <p className="mt-5 max-w-3xl text-lg leading-relaxed text-soft" data-id="element-70" data-mp="2gawuqlonaorw">
          En Radar Digital tenés una ruta para avanzar y encuentros conmigo para resolver lo que te frena.
        </p>
      </div>
    </section>;
}